import type { UserType } from "@/store";

import { STEPS } from "../";
import Details from "./details";
import Username from "./username";

interface SignUpProps {
  onComplete(user: UserType): void;
  onUsername(): void;
  step: STEPS;
}

export default function SignUp({ onComplete, onUsername, step }: SignUpProps) {
  if (step === STEPS.USERNAME) {
    return <Username onComplete={onUsername} />;
  }

  return <Details onComplete={onComplete} />;
}
